import { render, staticRenderFns } from "./addServRecommend.vue?vue&type=template&id=4b96f952&scoped=true"
import script from "./addServRecommend.vue?vue&type=script&lang=js"
export * from "./addServRecommend.vue?vue&type=script&lang=js"
import style0 from "./addServRecommend.vue?vue&type=style&index=0&id=4b96f952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96f952",
  null
  
)

export default component.exports